import { Button, IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import ItemStatus from "../../../../../../common/components/item_status";

/**
 * GenerateCargosListaColumns
 */

type Props = {
  onActionEdit: (idCargo: number | null, openNewTab: boolean) => void,
  onActionDelete: (idCargo: number | null, openState: boolean) => void,
  onActionExportar: (idCargo: number) => void,
  onActionCopy: (idCargo: number, openState: boolean) => void,
};

export const GenerateCargosListaColumns = ({
  onActionEdit,
  onActionDelete,
  onActionExportar,
  onActionCopy,
}: Props): GridColDef[] => {
  const computeItemStatusTitle = (status: number) => {
    switch (status) {
      case 1:
        return "A";
      case 0:
        return "I";
      default:
        return "?";
    }
  };

  const computeItemStatusColor = (status: number) => {
    switch (status) {
      case 1:
        return "green";
      case 0:
        return "red";
      default:
        return "blue";
    }
  };

  const computeItemStatusDescription = (status: number) => {
    switch (status) {
      case 1:
        return "Ativo";
      case 0:
        return "Inativo";
      default:
        return "?";
    }
  };

  return [
    {
      field: "ativo",
      filterable: false,
      headerName: "Status",
      minWidth: 75,
      width: 75,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            title={computeItemStatusTitle(params.value ? 1 : 0)}
            color={computeItemStatusColor(params.value ? 1 : 0)}
            description={computeItemStatusDescription(params.value ? 1 : 0)} />
        </div>
      )
    },
    {
      field: "descricao",
      filterable: false,
      headerName: "Nome",
      flex: 1,
      minWidth: 150,
      sortable: false,
    },
    {
      field: 'acoes',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      minWidth: 100,
      valueGetter: (_, row) => row['idCargo'] as number,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton
              onMouseDown={e => {
                if (e.button === 1) {
                  onActionEdit(params.value, true);
                } else {
                  onActionEdit(params.value, e.ctrlKey);
                }
                e.preventDefault();
              }}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => onActionDelete(params.value, true)}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
    {
      field: "exportar",
      filterable: false,
      headerName: "Exportar",
      sortable: false,
      valueGetter: (_, row) => row['idCargo'] as number,
      renderCell: ({ value }) => {
        return (
          <Button
            onMouseDown={() => onActionExportar(value)}
            sx={{
              fontSize: 11,
              paddingX: '.4rem',
              paddingY: 0,
              background: '#e6e6e6',
              borderLeft: '.2rem solid #45b6af',
              borderRadius: 0,
              color: 'black',
              fontWeight: 'normal',
            }}>
            Exportar
          </Button>
        );
      },
    },
    {
      field: 'idCargoCopia',
      sortable: false,
      filterable: false,
      headerName: 'Copiar',
      width: 75,
      valueGetter: (_, row) => row['idCargo'] as number,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton onClick={() => onActionCopy(params.value, true)}>
              <DynamicIcon nameIcon="ContentCopy" size={25} className="text-purple-500" />
            </IconButton>
          </div>
        );
      }
    }
  ];
}